import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { initDiveLogSync } from '@/lib/diveLogSync'

/**
 * Avvia la sincronizzazione offline delle immersioni (QuickLog) e avvisa quando la
 * coda viene inviata al ritorno della rete. Montato una volta nell'AppLayout.
 */
export default function OfflineSyncManager() {
  const { t } = useTranslation()
  useEffect(() => {
    initDiveLogSync((count) => {
      toast.success(
        count === 1
          ? t('offline.diveSyncedOne', 'Immersione offline sincronizzata.')
          : t('offline.diveSyncedMany', { defaultValue: '{{count}} immersioni offline sincronizzate.', count }),
      )
    })
  }, [t])
  return null
}
